import { render, staticRenderFns } from "./ReAllocation.vue?vue&type=template&id=49420075&scoped=true&lang=pug&"
import script from "./ReAllocation.vue?vue&type=script&lang=ts&"
export * from "./ReAllocation.vue?vue&type=script&lang=ts&"
import style0 from "./ReAllocation.vue?vue&type=style&index=0&id=49420075&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49420075",
  null
  
)

export default component.exports